export default __webpack_public_path__ + "static/play-7339ba9fa40069c7b68f05c3836bbac4.png";